/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClusterEventsBodiesFilter = {
    /**
     * Select objects where feature `age_group` takes one of these values
     */
    age_group?: Array<'0-16' | '17-35' | '36-50' | '50+'>;
    /**
     * Select objects where feature `bag_back` takes one of these values
     */
    bag_back?: Array<'back' | 'none'>;
    /**
     * Select objects where feature `bag_ground` takes one of these values
     */
    bag_ground?: Array<'ground' | 'none'>;
    /**
     * Select objects where feature `bag_hand` takes one of these values
     */
    bag_hand?: Array<'hand' | 'none'>;
    /**
     * Select objects where feature `gender` takes one of these values
     */
    body_gender?: Array<'female' | 'male'>;
    /**
     * Select objects where feature `color` takes one of these values
     */
    bottom_color?: Array<'beige' | 'black' | 'blue' | 'brown' | 'green' | 'grey' | 'lightblue' | 'orange' | 'pink' | 'purple' | 'red' | 'violet' | 'white' | 'yellow'>;
    /**
     * Select objects related to this `camera group`
     */
    camera_groups?: Array<number>;
    /**
     * Select objects related to this `camera`.
     */
    cameras?: Array<number>;
    /**
     * Select cluster events related to these `cases`
     */
    case_in?: Array<number | null>;
    /**
     * Select objects where the `cluster` id takes one of these values
     */
    cluster_in?: Array<number>;
    /**
     * Select objects with `created_date` **greater** than this value
     */
    created_date_gt?: string;
    /**
     * Select objects with `created_date` **greater than or equal** to this value
     */
    created_date_gte?: string;
    /**
     * Select objects with `created_date` in last N days
     */
    created_date_last_n_days?: number;
    /**
     * Select objects with `created_date` **less** than this value
     */
    created_date_lt?: string;
    /**
     * Select objects with `created_date` **less than or equal** to this value
     */
    created_date_lte?: string;
    /**
     * Select objects with `created_date` in last Nth week (including Sunday and Saturday)
     */
    created_date_nth_full_week?: number;
    /**
     * Select objects with `created_date` in last Nth week (only working days, i.e. excluding Sunday and Saturday)
     */
    created_date_nth_work_week?: number;
    /**
     * Select objects where feature `detailed_upper_clothes` takes one of these values
     */
    detailed_upper_clothes?: Array<'coat' | 'dress' | 'jacket' | 'shirt' | 'sleeveless' | 'sweatshirt' | 't-shirt'>;
    /**
     * Select objects related to this `episode`
     */
    episodes?: Array<number>;
    /**
     * `true` - select only cluster events relates to case. `false` - select only cluster events without case.
     */
    has_case?: boolean;
    /**
     * `true` - select only cluster events with matches. `false` - select only cluster events without matches.
     */
    has_matches?: boolean;
    /**
     * Select objects where feature `headwear` takes one of these values
     */
    headwear?: Array<'hat' | 'hood' | 'none'>;
    /**
     * Select objects where feature `helmet_type` takes one of these values
     */
    helmet_type?: Array<'none' | 'not_visible' | 'other' | 'red/orange' | 'white'>;
    /**
     * Select cluster events with provided ids
     */
    id_in?: Array<number>;
    /**
     * Number of results to return per page.
     */
    limit?: string;
    /**
     * Select objects where feature `lower_clothes` takes one of these values
     */
    lower_clothes?: Array<'obscured' | 'pants' | 'shorts' | 'skirt'>;
    /**
     * Filter is deprecated
     */
    matched_card?: number;
    /**
     * Select objects that match these cards
     */
    matched_card_in?: Array<number>;
    /**
     * Select objects that match a card included in these watch lists
     */
    matched_lists?: Array<number>;
    /**
     * Which field to use when ordering the results. Available fields: `id`, `created_date`
     */
    ordering?: string;
    /**
     * Pagination cursor value.
     */
    page?: string;
    /**
     * Select objects where feature `top_color` takes one of these values
     */
    top_color?: Array<'beige' | 'black' | 'blue' | 'brown' | 'green' | 'grey' | 'lightblue' | 'orange' | 'pink' | 'purple' | 'red' | 'violet' | 'white' | 'yellow'>;
    /**
     * Select objects where feature `upper_clothes` takes one of these values
     */
    upper_clothes?: Array<'long_sleeves' | 'short_sleeves' | 'without_sleeves'>;
    /**
     * Select objects where feature `vest_type` takes one of these values
     */
    vest_type?: Array<'green/yellow' | 'none' | 'not_visible' | 'orange'>;
}
export const EmptyClusterEventsBodiesFilter: ClusterEventsBodiesFilter = {
    age_group: [],
    bag_back: [],
    bag_ground: [],
    bag_hand: [],
    body_gender: [],
    bottom_color: [],
    camera_groups: [],
    cameras: [],
    case_in: [],
    cluster_in: [],
    created_date_gt: undefined,
    created_date_gte: undefined,
    created_date_last_n_days: undefined,
    created_date_lt: undefined,
    created_date_lte: undefined,
    created_date_nth_full_week: undefined,
    created_date_nth_work_week: undefined,
    detailed_upper_clothes: [],
    episodes: [],
    has_case: undefined,
    has_matches: undefined,
    headwear: [],
    helmet_type: [],
    id_in: [],
    limit: '20',
    lower_clothes: [],
    matched_card: undefined,
    matched_card_in: [],
    matched_lists: [],
    ordering: '-id',
    page: undefined,
    top_color: [],
    upper_clothes: [],
    vest_type: [],
}